import { ORDER_TYPE_CODE } from '@wyz/utils';
import React from 'react';
import FormatDate from './format-date';

type DateFormatProps = React.ComponentProps<typeof FormatDate>;
type Props = DateFormatProps & {
  orderType: string | null | undefined;
  backorderContent: React.ReactNode;
};

const FormatDeliveryDate: React.FC<Props> = ({
  orderType,
  backorderContent,
  date,
  format,
  timezone,
  fallback,
  locale,
}: Props) => {
  if (orderType === ORDER_TYPE_CODE.BO) {
    return <>{backorderContent}</>;
  }

  return (
    <FormatDate
      date={date}
      format={format}
      timezone={timezone}
      fallback={fallback}
      locale={locale}
    />
  );
};

export default FormatDeliveryDate;
